<template>
    <div class="mt-2">
        <b-card header-tag="header" footer-tag="footer" class="d-flex min-330 mb-2" v-if="ready">
            <template #header>
                <b-row class="pb-2">
                    <b-col class="col-7 text-start">
                        <span><small><b>{{ title }}</b></small></span>
                    </b-col>
                    <b-col class="col-5 text-end">
                        <span class="badge badge-unknown pointer" @click="toggleFooter">
                            Details
                        </span>
                        <button type="button" class="btn btn-light btn-sm" @click="refresh()">
                            <i class="fa-solid fa-arrows-rotate">
                            </i>
                        </button>
                    </b-col>
                </b-row>
            </template>
            <b-card-body v-if="ready">
                <loading v-model:active="isLoading"
                         :is-full-page="fullPage"/>
                <div class="d-flex justify-content-between">
                    <div>
                        <div class="ebox">
                            <v-chart :option="echartTotalOptions"/>
                        </div>
                    </div>
                    <div>
                        <div class="text-center ebox" @click="goTo('warning', 'warning')">
                            <v-chart :option="echartWarningOptions"/>
                        </div>
                    </div>
                    <div>
                        <div class="text-center ebox" @click="goTo('critical', 'critical')">
                            <v-chart :option="echartCriticalOptions"/>
                        </div>
                    </div>
                    <div>
                        <div class="ebox" @click="goTo('unknown', 'unknown')">
                            <v-chart :option="echartUnknownOptions"/>
                        </div>
                    </div>
                </div>
            </b-card-body>
            <template #footer v-if="showFooter">
                <div class="d-flex justify-content-between">
                    <div class="col-3">
                        <div class="bold mb-4 mleft--10">
                            <small class="fsize10"><i class="fa-solid fa-triangle-exclamation warning"></i>
                                {{ $t('unhandled') }}</small>
                        </div>
                        <div class="bold mb-4 mleft--10">
                            <small class="fsize10"><i class="fa-solid fa-user"></i> {{ $t('Acknowledged') }}</small>
                        </div>
                        <div class="bold mb-4 .mleft--10">
                            <small class="fsize10"><i class="fa-solid fa-power-off"></i> {{ $t('In downtime') }}</small>
                        </div>
                    </div>
                    <div class="col-3 text-center">
                        <div class="mb-4">
                            <b-badge pill variant="warning" class="w-100" :class="[not_handled[1] > 0 ? 'pointer': '']"
                                     @click="goTo('warning', 'not_handled')"><i
                                class="fa-solid fa-triangle-exclamation"></i> {{ not_handled[1] }}
                            </b-badge>
                        </div>
                        <div class="mb-4">
                            <b-badge pill variant="warning" class="w-100" :class="[acknowledged[1] > 0 ? 'pointer': '']"
                                     @click="goTo('warning', 'acknowledged')"><i class="fa-solid fa-user"></i>
                                {{ acknowledged[1] }}
                            </b-badge>
                        </div>
                        <div class="mb-4">
                            <b-badge pill variant="warning" class="w-100" :class="[downtimes[1] > 0 ? 'pointer': '']"
                                     @click="goTo('warning', 'downtimes')"><i class="fa-solid fa-power-off"></i>
                                {{ downtimes[1] }}
                            </b-badge>
                        </div>
                    </div>
                    <div class="col-3 text-center">
                        <div class="mb-4 ps-2">
                            <b-badge pill variant="danger" class="w-100" :class="[not_handled[2] > 0 ? 'pointer': '']"
                                     @click="goTo('critical', 'not_handled')"><i
                                class="fa-solid fa-triangle-exclamation warning"></i> {{ not_handled[2] }}
                            </b-badge>
                        </div>
                        <div class="mb-4 ps-2">
                            <b-badge pill variant="danger" class="w-100" :class="[acknowledged[2] > 0 ? 'pointer': '']"
                                     @click="goTo('critical', 'acknowledged')"><i class="fa-solid fa-user"></i>
                                {{ acknowledged[2] }}
                            </b-badge>
                        </div>
                        <div class="mb-4 ps-2">
                            <b-badge pill variant="danger" class="w-100" :class="[downtimes[2] > 0 ? 'pointer': '']"
                                     @click="goTo('critical', 'downtimes')"><i class="fa-solid fa-power-off"></i>
                                {{ downtimes[2] }}
                            </b-badge>
                        </div>
                    </div>
                    <div class="col-3 text-center">
                        <div class="mb-4 ps-2">
                            <b-badge pill variant="secondary" class="w-100"
                                     :class="[not_handled[3] > 0 ? 'pointer': '']"
                                     @click="goTo('unknown', 'not_handled')"><i
                                class="fa-solid fa-triangle-exclamation warning"></i> {{ not_handled[3] }}
                            </b-badge>
                        </div>
                        <div class="mb-4 ps-2">
                            <b-badge pill variant="secondary" class="w-100"
                                     :class="[acknowledged[3] > 0 ? 'pointer': '']"
                                     @click="goTo('unknown', 'acknowledged')"><i class="fa-solid fa-user"></i>
                                {{ acknowledged[3] }}
                            </b-badge>
                        </div>
                        <div class="mb-4 ps-2">
                            <b-badge pill variant="secondary" class="w-100" :class="[downtimes[3] > 0 ? 'pointer': '']"
                                     @click="goTo('unknown', 'downtimes')"><i class="fa-solid fa-power-off"></i>
                                {{ downtimes[3] }}
                            </b-badge>
                        </div>
                    </div>
                </div>
            </template>
        </b-card>
    </div>
</template>
<script>
import "echarts-liquidfill";
import VChart from 'vue-echarts';
import router from '../../router';
import Loading from 'vue-loading-overlay';
import { BBadge } from 'bootstrap-vue-next';

export default {
    name: "TacticalServiceWidget",
    components: {
        BBadge,
        VChart,
        Loading
    },
    props: ['title', 'widget_id', 'theme'],
    data() {
        return {
            isLoading: false,
            fullPage: false,
            ready: false,
            showFooter: false,
            permissions: {},
            widgetData: {},
            stateSummary: [],
            not_handled: [],
            acknowledged: [],
            downtimes: [],
            totalSeries: [],
            warning: [],
            critical: [],
            unknown: [],
            total: 0,
            servicesFilter: {
                filter: {
                    id: []
                }
            },
            echartTotalOptions: {
                series: [{
                    type: 'liquidFill',
                    radius: "100%",
                    data: [0, 0, 0, 0],
                    color: ['#00ea5f', '#f9d180', '#ff4444', '#868e96'],
                    waveAnimation: false,
                    amplitude: 0,
                    // animationDuration: 2000,
                    // animationDurationUpdate: 2000,
                    // animationEasingUpdate: 'cubicOut',
                    // phase: 0,
                    //period: 5000,

                    // amplitude: 3,

                    backgroundStyle: {
                        borderWidth: 5,
                        color: '#706b6b'
                        // borderColor: 'red',
                    },
                    outline: {
                        show: false,
                        borderDistance: 3,
                        itemStyle: {
                            borderColor: "#CC0000",
                            borderWidth: 3
                        }
                    },
                    label: {
                        show: true,
                        color: "white",
                        insideColor: "white",
                        fontSize: 12,
                        fontWeight: "bold",
                        formatter: function(param) {
                            return 'Total' + '\n' + param.seriesName;
                        }
                    }
                }]
            },
            echartWarningOptions: {
                series: [
                    {
                        type: "liquidFill",
                        name: "Liquid Fill",
                        radius: "100%",
                        data: [0],
                        period: 5000,
                        label: {
                            color: "white",
                            insideColor: "white",
                            fontSize: 12,
                            fontWeight: "bold",
                            formatter: function(param) {
                                return 'Warn' + '\n' + param.seriesName + '\n' + '(' + parseInt(param.value * 100) + '%)';
                            }
                        },
                        color: ['rgba(255, 99, 71, 0.5)'],
                        outline: {
                            show: false,
                            borderDistance: 3,
                            itemStyle: {
                                borderColor: '#f9d180',
                                borderWidth: 3
                            }
                        },
                        backgroundStyle: {
                            borderWidth: 5,
                            // borderColor: 'red',
                            color: '#f9d180'
                        }
                    }
                ]
            },
            echartCriticalOptions: {
                series: [
                    {
                        type: "liquidFill",
                        name: "liquid Fill",
                        radius: "100%",
                        data: [0],
                        period: 5000,
                        label: {
                            color: "white",
                            insideColor: "white",
                            fontSize: 12,
                            fontWeight: "bold",
                            formatter: function(param) {
                                return 'Crit,' + '\n' + param.seriesName + '\n' + '(' + parseInt(param.value * 100) + '%)';
                            }
                        },
                        color: ['#CC0000'],
                        outline: {
                            show: false,
                            borderDistance: 3,
                            itemStyle: {
                                borderColor: "#CC0000",
                                borderWidth: 3
                            }
                        },
                        backgroundStyle: {
                            borderWidth: 5,
                            // borderColor: 'red',
                            color: 'rgba(255, 99, 71, 0.5)'
                        }
                    }
                ]
            },
            echartUnknownOptions: {
                series: [
                    {
                        type: "liquidFill",
                        name: "Liquid Fill",
                        radius: "100%",
                        data: [0],
                        period: 5000,
                        label: {
                            color: "white",
                            insideColor: "white",
                            fontSize: 12,
                            fontWeight: "bold",
                            formatter: function(param) {
                                return 'Unk,' + '\n' + param.seriesName + '\n' + '(' + parseInt(param.value * 100) + '%)';
                            }
                        },
                        color: ['#868e96'],

                        outline: {
                            show: false,
                            borderDistance: 3,
                            itemStyle: {
                                borderColor: "#CC0000",
                                borderWidth: 3
                            }
                        },
                        backgroundStyle: {
                            borderWidth: 5,
                            // borderColor: 'red',
                            color: 'LightGray'
                        }
                    }
                ]
            }
        }
    },
    mounted() {
        this.permissions = this.$store.state.permissions;
        this.getWidget();
    },
    methods: {
        toggleFooter: function() {
            this.showFooter = !this.showFooter;
        },
        refresh: function() {
            this.getWidget();
        },
        getWidget: function() {
            this.isLoading = true;
            axios.post('/dashboards/getTacticalOverviewWidget.json', null, {
                params: {
                    type: 'services',
                    id: this.widget_id
                }
            }).then(result => {
                this.widgetData = result.data.widgetData;
                this.total = this.widgetData.servicestatusSummary.total;
                this.stateSummary = this.widgetData.servicestatusSummary.state;
                const ok = parseInt(this.widgetData.servicestatusSummary.state[0] / this.total * 100);
                const warning = parseInt(this.widgetData.servicestatusSummary.state[1] / this.total * 100);
                const critical = parseInt(this.widgetData.servicestatusSummary.state[2] / this.total * 100);
                const unknown = parseInt(this.widgetData.servicestatusSummary.state[3] / this.total * 100);
                this.warning = [warning];
                this.critical = [critical];
                this.unknown = [unknown];
                this.totalSeries = [
                    ok,
                    warning,
                    critical,
                    unknown
                ];
                let sortArray = [
                    {key: '#00ea5f', value: ok},
                    {key: '#f9d180', value: warning},
                    {key: '#ff4444', value: critical},
                    {key: '#868e96', value: unknown}
                ];
                sortArray.sort((a, b) => b.value - a.value);
                this.echartTotalOptions.series[0].data = [sortArray[0].value / 100, sortArray[1].value / 100, sortArray[2].value / 100, sortArray[3].value / 100];
                this.echartTotalOptions.series[0].color = [sortArray[0].key, sortArray[1].key, sortArray[2].key, sortArray[3].key];
                this.echartTotalOptions.series[0].name = ( this.total ).toString();
                this.echartWarningOptions.series[0].data = [warning / 100];
                this.echartWarningOptions.series[0].name = ( this.stateSummary[1] ).toString();
                this.echartCriticalOptions.series[0].data = [critical / 100];
                this.echartCriticalOptions.series[0].name = ( this.stateSummary[2] ).toString();
                this.echartUnknownOptions.series[0].data = [unknown / 100];
                this.echartUnknownOptions.series[0].name = ( this.stateSummary[3] ).toString();
                this.not_handled = this.widgetData.servicestatusSummary.not_handled;
                this.acknowledged = this.widgetData.servicestatusSummary.acknowledged;
                this.downtimes = this.widgetData.servicestatusSummary.in_downtime;
                this.ready = true;

            }).catch(error => {
                console.log(error);
            }).finally(() => {
                this.isLoading = false;
            });
        },
        goTo: function(state, type) {
            switch(state) {
                case 'all': {
                    if(!this.servicePermissions) {
                        break;
                    }
                    const combined = [].concat(this.stateSummary.serviceIds[0], this.stateSummary.serviceIds[1], this.stateSummary.serviceIds[2], this.stateSummary.serviceIds[3]);
                    if(combined.length > 0) {
                        this.servicesFilter.filter.id = combined;
                        this.$store.commit('setServicesIndexFilter', this.servicesFilter);
                        router.push({name: 'servicesIndexFilter'});
                        //router.push({name: 'servicesIndexFilter', params: {filter: JSON.stringify(this.servicesFilter)}});
                    }
                    break;
                }
                case 'warning': {
                    switch(type) {
                        case 'warning': {
                            if(!this.servicePermissions) {
                                break;
                            }
                            if(this.stateSummary.serviceIds[1].length > 0) {
                                this.servicesFilter.filter.id = this.stateSummary.serviceIds[1];
                                this.$store.commit('setServicesIndexFilter', this.servicesFilter);
                                router.push({name: 'servicesIndexFilter'});
                                //router.push({name: 'servicesIndexFilter', params: {filter: JSON.stringify(this.servicesFilter)}});
                            }
                            break;
                        }
                        case 'not_handled': {
                            if(!this.servicePermissions) {
                                break;
                            }
                            if(this.not_handled.serviceIds[1].length > 0) {
                                this.servicesFilter.filter.id = this.not_handled.serviceIds[1];
                                this.$store.commit('setServicesIndexFilter', this.servicesFilter);
                                router.push({name: 'servicesIndexFilter'});
                                //router.push({name: 'servicesIndexFilter', params: {filter: JSON.stringify(this.servicesFilter)}});
                            }
                            break;
                        }
                        case 'acknowledged': {
                            if(!this.servicePermissions) {
                                break;
                            }
                            if(this.acknowledged.serviceIds[1].length > 0) {
                                this.servicesFilter.filter.id = this.acknowledged.serviceIds[1];
                                this.$store.commit('setServicesIndexFilter', this.servicesFilter);
                                router.push({name: 'servicesIndexFilter'});
                                //router.push({name: 'servicesIndexFilter', params: {filter: JSON.stringify(this.servicesFilter)}});
                            }
                            break;
                        }
                        case 'downtimes': {
                            if(!this.servicePermissions) {
                                break;
                            }
                            if(this.downtimes.serviceIds[1].length > 0) {
                                this.servicesFilter.filter.id = this.downtimes.serviceIds[1];
                                this.$store.commit('setServicesIndexFilter', this.servicesFilter);
                                router.push({name: 'servicesIndexFilter'});
                                //router.push({name: 'servicesIndexFilter', params: {filter: JSON.stringify(this.servicesFilter)}});
                            }
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                    break;
                }
                case 'critical': {
                    switch(type) {
                        case 'critical': {
                            if(!this.servicePermissions) {
                                break;
                            }
                            if(this.stateSummary.serviceIds[2].length > 0) {
                                this.servicesFilter.filter.id = this.stateSummary.serviceIds[2];
                                this.$store.commit('setServicesIndexFilter', this.servicesFilter);
                                router.push({name: 'servicesIndexFilter'});
                                // router.push({name: 'servicesIndexFilter', params: {filter: JSON.stringify(this.servicesFilter)}});
                            }
                            break;
                        }
                        case 'not_handled': {
                            if(!this.servicePermissions) {
                                break;
                            }
                            if(this.not_handled.serviceIds[2].length > 0) {
                                this.servicesFilter.filter.id = this.not_handled.serviceIds[2];
                                this.$store.commit('setServicesIndexFilter', this.servicesFilter);
                                router.push({name: 'servicesIndexFilter'});
                                //router.push({name: 'servicesIndexFilter', params: {filter: JSON.stringify(this.servicesFilter)}});
                            }
                            break;
                        }
                        case 'acknowledged': {
                            if(!this.servicePermissions) {
                                break;
                            }
                            if(this.acknowledged.serviceIds[2].length > 0) {
                                this.servicesFilter.filter.id = this.acknowledged.serviceIds[2];
                                this.$store.commit('setServicesIndexFilter', this.servicesFilter);
                                router.push({name: 'servicesIndexFilter'});
                                //router.push({name: 'servicesIndexFilter', params: {filter: JSON.stringify(this.servicesFilter)}});
                            }
                            break;
                        }
                        case 'downtimes': {
                            if(!this.servicePermissions) {
                                break;
                            }
                            if(this.downtimes.serviceIds[2].length > 0) {
                                this.servicesFilter.filter.id = this.downtimes.serviceIds[2];
                                this.$store.commit('setServicesIndexFilter', this.servicesFilter);
                                router.push({name: 'servicesIndexFilter'});
                                //router.push({name: 'servicesIndexFilter', params: {filter: JSON.stringify(this.servicesFilter)}});
                            }
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                    break;
                }
                case 'unknown': {
                    switch(type) {
                        case 'unknown': {
                            if(!this.servicePermissions) {
                                break;
                            }
                            if(this.stateSummary.serviceIds[3].length > 0) {
                                this.servicesFilter.filter.id = this.stateSummary.serviceIds[3];
                                this.$store.commit('setServicesIndexFilter', this.servicesFilter);
                                router.push({name: 'servicesIndexFilter'});
                                //router.push({name: 'servicesIndexFilter', params: {filter: JSON.stringify(this.servicesFilter)}});
                            }
                            break;
                        }
                        case 'not_handled': {
                            if(!this.servicePermissions) {
                                break;
                            }
                            if(this.not_handled.serviceIds[3].length > 0) {
                                this.servicesFilter.filter.id = this.not_handled.serviceIds[3];
                                this.$store.commit('setServicesIndexFilter', this.servicesFilter);
                                router.push({name: 'servicesIndexFilter'});
                                //router.push({name: 'servicesIndexFilter', params: {filter: JSON.stringify(this.servicesFilter)}});
                            }
                            break;
                        }
                        case 'acknowledged': {
                            if(!this.servicePermissions) {
                                break;
                            }
                            if(this.acknowledged.serviceIds[3].length > 0) {
                                this.servicesFilter.filter.id = this.acknowledged.serviceIds[3];
                                this.$store.commit('setServicesIndexFilter', this.servicesFilter);
                                router.push({name: 'servicesIndexFilter'});
                                //router.push({name: 'servicesIndexFilter', params: {filter: JSON.stringify(this.servicesFilter)}});
                            }
                            break;
                        }
                        case 'downtimes': {
                            if(!this.servicePermissions) {
                                break;
                            }
                            if(this.downtimes.serviceIds[3].length > 0) {
                                this.servicesFilter.filter.id = this.downtimes.serviceIds[3];
                                this.$store.commit('setServicesIndexFilter', this.servicesFilter);
                                router.push({name: 'servicesIndexFilter'});
                                //router.push({name: 'servicesIndexFilter', params: {filter: JSON.stringify(this.servicesFilter)}});
                            }
                            break;
                        }
                        default: {
                            break;
                        }
                    }
                    break;
                }
                default: {
                    break;
                }
            }
        }
    },
    computed: {
        servicePermissions: function() {
            return !!( this.permissions.services && this.permissions.services.index );
        }
    }
}
</script>


<style scoped>
.max-600 {
    max-width: 600px !important;
}

.min-330 {
    min-width: 330px !important;
}

.fsize10 {
    font-size: 10px;
}

.pointer {
    cursor: pointer;
}

.ebox {
    width: 60px;
    height: 60px;
}

.mleft--10 {
    margin-left: -10px;
}
</style>
